import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";
// import axios from "axios";

export const fetchDocumentTypesStarted = () => {
  return {
    type: actionTypes.FETCH_DOCUMENT_TYPES_STARTED,
  };
};

export const fetchDocumentTypesSuccess = (documentTypes) => {
  return {
    type: actionTypes.FETCH_DOCUMENT_TYPES_SUCCESS,
    documentTypes: documentTypes,
  };
};

export const fetchDocumentTypesFailed = (errorMessage) => {
  return {
    type: actionTypes.FETCH_DOCUMENT_TYPES_FAILED,
    errorMessage: errorMessage,
  };
};

export const resetDocumentTypes = () => {
  return {
    type: actionTypes.RESET_DOCUMENT_TYPES,
  };
};
export const fetchDocumentTypes = (userId: string) => {
  return (dispatch) => {
    dispatch(fetchDocumentTypesStarted());
    axios
      .get(serverconfigs.fetchDocumentTypesUrl+`/${userId}`)
      .then((response) => {
        console.log(response.data);
        dispatch(fetchDocumentTypesSuccess(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            dispatch(fetchDocumentTypesFailed(error.response.data.message));
          } else {
            dispatch(fetchDocumentTypesFailed(error.message));
          }
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
          dispatch(fetchDocumentTypesFailed(error.message));
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
          dispatch(fetchDocumentTypesFailed(error.message));
        } else {
          dispatch(fetchDocumentTypesFailed(error.message));
        }
      });
  };
};
